import { useMemo } from 'react';

import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { convertResponseToOptions } from '../../../utils/utils';

import { getCLAOptions } from 'RestAPIs/admin';

import { ControlledSelect, showSnackbar } from 'components/shared';

type Props = {
  control: Control<any>;
  isEdit?: boolean;
  setValue?;
};

export function DutyCalculationValueSleepDutyCLACodeGroupSelect({
  control
}: Props) {
  const { t } = useTranslation();

  const { data } = useQuery({
    queryKey: ['dutyCalculationValueSleepDutyCLAGroupOpts'],
    queryFn: async () => {
      const { data } = await getCLAOptions();
      return data;
    },
    onError: () => {
      showSnackbar({
        severity: 'error',
        message: t('fetchError')
      });
    }
  });

  const options = useMemo(() => {
    return convertResponseToOptions(data);
  }, [data]);

  return (
    <ControlledSelect
      name={'claId'}
      options={options}
      control={control}
      variant="outlined"
      label={t('dutyCalculationValue.sleepDuty.grid.claId')}
    />
  );
}
